import questionData from "./aiAssistantQuestions.json";

export const AI_ASSISTANT_QUESTION_CATEGORIES = {
  stage: {
    label: "Aktualny etap",
    icon: "bi-signpost-split",
  },
  application: {
    label: "Wniosek i dane",
    icon: "bi-file-earmark-text",
  },
  documents: {
    label: "Dokumenty i załączniki",
    icon: "bi-paperclip",
  },
  verification: {
    label: "Weryfikacja wniosku",
    icon: "bi-search",
  },
  communication: {
    label: "Wiadomości i kontakt",
    icon: "bi-chat-left-text",
  },
  corrections: {
    label: "Poprawa wniosku",
    icon: "bi-pencil-square",
  },
  payment: {
    label: "Płatność",
    icon: "bi-credit-card",
  },
  cancellation: {
    label: "Anulowanie",
    icon: "bi-x-circle",
  },
  signature: {
    label: "Podpis",
    icon: "bi-pen",
  },
  certificate: {
    label: "Świadectwo",
    icon: "bi-patch-check",
  },
  delivery: {
    label: "Odbiór i wysyłka",
    icon: "bi-truck",
  },
};

const STATUS_CATEGORY_LAYOUT = {
  1: ["stage", "stage", "application", "application", "documents", "application"],
  2: ["stage", "stage", "application", "application", "application", "application"],
  3: ["stage", "stage", "verification", "verification", "communication", "application"],
  4: ["stage", "stage", "corrections", "communication", "corrections", "corrections"],
  5: ["stage", "stage", "payment", "payment", "payment", "payment"],
  6: ["stage", "stage", "payment", "payment", "payment", "payment", "payment"],
  7: ["stage", "stage", "cancellation", "cancellation", "cancellation", "cancellation"],
  8: ["stage", "stage", "cancellation", "cancellation", "certificate", "application"],
  9: ["stage", "stage", "payment", "payment", "payment", "signature"],
  10: ["stage", "stage", "signature", "signature", "signature", "signature"],
  11: ["stage", "stage", "payment", "payment", "payment", "payment", "payment"],
  12: ["stage", "stage", "signature", "signature", "signature", "signature", "signature"],
  13: ["stage", "stage", "verification", "verification", "certificate", "communication"],
  14: ["stage", "stage", "certificate", "certificate", "delivery", "delivery"],
  15: ["stage", "stage", "delivery", "delivery", "delivery", "delivery", "certificate"],
  16: ["stage", "stage", "delivery", "delivery", "delivery", "delivery", "certificate"],
  17: ["stage", "stage", "delivery", "delivery", "delivery", "delivery", "certificate"],
  18: ["stage", "stage", "certificate", "certificate", "certificate", "certificate", "certificate"],
  19: ["stage", "stage", "certificate", "certificate", "certificate", "certificate", "communication"],
};

const FEATURED_QUESTION_COUNT = 3;

const createQuestionId = (statusId, index) =>
  `status_${String(statusId).padStart(2, "0")}_question_${String(
    index + 1,
  ).padStart(2, "0")}`;

export const getAiAssistantQuestionSet = (statusId) => {
  const normalizedStatusId = Number(statusId);
  const statusKey = String(normalizedStatusId);
  const rawQuestions = questionData[statusKey];
  const categoryLayout = STATUS_CATEGORY_LAYOUT[normalizedStatusId] || [];

  if (!Number.isInteger(normalizedStatusId) || !Array.isArray(rawQuestions)) {
    return {
      statusId: normalizedStatusId,
      statusName: questionData._statusNames?.[statusKey] || "Nieznany",
      questions: [],
      featuredQuestions: [],
      categories: [],
    };
  }

  const questions = rawQuestions.map((text, index) => ({
    id: createQuestionId(normalizedStatusId, index),
    text,
    categoryId: categoryLayout[index] || "application",
    featured: index < FEATURED_QUESTION_COUNT,
  }));

  const categories = Object.keys(AI_ASSISTANT_QUESTION_CATEGORIES)
    .map((categoryId) => ({
      id: categoryId,
      ...AI_ASSISTANT_QUESTION_CATEGORIES[categoryId],
      questions: questions.filter(
        (question) => question.categoryId === categoryId,
      ),
    }))
    .filter((category) => category.questions.length > 0);

  return {
    statusId: normalizedStatusId,
    statusName: questionData._statusNames?.[statusKey] || "Nieznany",
    questions,
    featuredQuestions: questions.filter((question) => question.featured),
    categories,
  };
};
